var $ = require('jquery');
var _ = require('underscore');
var TorsoService = require('backbone-torso/modules/ServiceCell');
var portalUserExtService = require('./../urls').portalUserExtService;
var TorsoNestedModel = require('backbone-torso/modules/NestedModel');
var currentPortalUserModel = require('./../user/currentPortalUserModel');

/**
 * Service that upates Patient Portal settings.
 *
 * @class patientSettingsService
 * @constructor
 */
module.exports = new (TorsoService.extend({

  /**
   * @method initialize
   * @override
   */
  initialize: function() {
    _.bindAll(this, 'resetAndFetchModel');
  },

  /**
   * Fetch current portal user model
   * @method fetchCurrentPortalUserModel
   */
  fetchCurrentPortalUserModel: function() {
    this.currentPortalUserModel = currentPortalUserModel;
    currentPortalUserModel.fetch();
    return this.currentPortalUserModel;
  },

  /**
   * Update settings in Patient Portal.
   * @method saveSettings
   */
  saveSettings: function(patientSettingsFormModel, patientVecnaId) {
    if (!this.currentPortalUserModel) {
      this.fetchCurrentPortalUserModel();
    }

    var portalUserModel = new TorsoNestedModel();
    portalUserModel = _.extend(portalUserModel, this.currentPortalUserModel);
    patientSettingsFormModel.trackModel('portalUserModel', portalUserModel);
    patientSettingsFormModel.push();
    patientSettingsFormModel.untrackModel('portalUserModel', portalUserModel);

    return $.ajax({
      method: 'PUT',
      url: portalUserExtService + '/' + patientVecnaId,
      data: JSON.stringify(portalUserModel.toJSON()),
      contentType: 'application/json;charset=utf-8'
    });
  },

  /**
   * Reset the portal user model and re-fetch.
   *
   * @method resetAndFetchModel
   */
  resetAndFetchModel: function() {
    this.currentPortalUserModel.clear();
    return this.currentPortalUserModel.fetch();
  }
}))();
